import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { uuidv7 } from "uuidv7";
import Cookies from "js-cookie";
import PageLoader from "@/components/uikit/PageLoader.vue";
import { useGameStore } from "@/stores/index";
// import { onMounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useGameStore();
const userId = Cookies.get("user_id");

if (!userId) {
  const newUserId = uuidv7();
  Cookies.set("user_id", newUserId, { expires: 7 });
}

// onMounted(() => store.startGame());

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(PageLoader, {
      class: _normalizeClass({ 'loader--active': _unref(store).loader })
    }, null, 8, ["class"])
  ], 64))
}
}

})